<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <index-table id="user-deleted-index-table" endpoint="usersIndexDeleted" title="Users" icon="supervisor_account">
                <template slot="head">
                    <index-table-head slug="isFederatedUser">Federated</index-table-head>
                    <index-table-head slug="firstName">First name</index-table-head>
                    <index-table-head slug="lastName">Last name</index-table-head>
                    <index-table-head slug="email">Email</index-table-head>
                    <index-table-head slug="isActive" class="text-center">Is active</index-table-head>
                    <index-table-head slug="deletedAt" class="text-center">Deleted at</index-table-head>
                    <index-table-head slug="actions" :sortable="false" class="text-center"></index-table-head>
                </template>
                <md-table-row class="search">
                    <md-table-cell></md-table-cell>
                    <index-table-filter-text slug="firstName"></index-table-filter-text>
                    <index-table-filter-text slug="lastName"></index-table-filter-text>
                    <index-table-filter-text slug="email"></index-table-filter-text>
                    <index-table-filter-bool slug="isActive"></index-table-filter-bool>
                    <index-table-filter-date slug="deletedAt"></index-table-filter-date>
                    <md-table-cell></md-table-cell>
                </md-table-row>
                <users-deleted-row v-for="(item, key) in items" :key="key" :item="item"/>
            </index-table>
        </div>
    </div>
</template>

<script>

    import {mapGetters, mapMutations} from "vuex";
    import IndexTable from "../../../components/Index/IndexTable";
    import IndexTableHead from "../../../components/Index/IndexTableHead";
    import IndexTableFilterText from "@/new/components/Index/IndexTableFilterText";
    import IndexTableFilterBool from "@/new/components/Index/IndexTableFilterBool";
    import IndexTableFilterDate from "@/new/components/Index/IndexTableFilterDate";
    import UsersDeletedRow from "./UsersDeletedRow";

    export default {
        name: "UsersDeleted",
        components: {UsersDeletedRow, IndexTableHead, IndexTable, IndexTableFilterText, IndexTableFilterBool, IndexTableFilterDate},
        computed: {
            ...mapGetters('indexTable', {
                items: 'getItems',
            }),
        },
        methods: {
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            }),
        },
        mounted() {
            this.setTitlePage(this.$t('Users'));
        }
    }
</script>

<style scoped>

</style>
